"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeInvoke = exports.omitProps = exports.custom = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var test = RegExp.prototype.test;

var filter = function filter(fn, props) {
  return Object.entries(props).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return fn(key) && (acc[key] = val), acc;
  }, {});
};

var custom = filter.bind(null, test.bind(/^(data|aria)-/));
exports.custom = custom;

var omitProps = function omitProps(props) {
  for (var _len = arguments.length, propsToIgnore = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    propsToIgnore[_key - 1] = arguments[_key];
  }

  var rest = {};
  Object.keys(props).forEach(function (key) {
    // TODO revert to .find() after webpack 4 babel-polyfill
    if (propsToIgnore.filter(function (p) {
      return p === key;
    }).length === 0) rest[key] = props[key];
  });
  return rest;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */


exports.omitProps = omitProps;

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fn.apply(void 0, args);
  }
};

exports.safeInvoke = safeInvoke;